import { IPromise, IScope } from 'angular'

import { $q } from '../../../ng-compat/imports'

interface PartialAuthModalOptions {
  approvedAmount: number
}

/**
 * Controller class for the partial auth modal.
 *
 * @class PartialAuthModalController
 */
export class PartialAuthModalController {
  public readonly close: () => void
  public readonly approvedAmount: number
  private readonly internalClose: (val: IPromise<boolean>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<boolean>) => void,
    public readonly options: PartialAuthModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    this.approvedAmount = options.approvedAmount

    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
